import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";

import { Influencer, InfluencerContact } from "@shared/lib/types/influencer";
import { AgencyService } from "../services/agency.service";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { Agency, Review } from "@shared/lib/types/agency";

export function useAddReview() {
  const {
    mutate: addReview,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation<
    { agencyId: string; review: Pick<Review, "comment" | "review"> },
    BackednResponse<Agency> | void
  >({
    mutationFn: async ({ agencyId, review }) => {
      return await AgencyService.addReview(agencyId, review).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { agencyId }) => {
      c.invalidateQueries({ queryKey: AGENCY_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
    },
  });

  return {
    addReview,
    isAdding,
    isAdded,
  };
}
